import React from "react";
import Title from "ui/Title/Title";
import Modal from "ui/Modal/Modal";
import Price from "common/Price/Price";
import AddToCart from "common/AddToCart/AddToCart";
import { formatDate } from "helpers/date";
import { useProductPrices } from "helpers/hooks";
import { PRICES } from "constants/variables";
import styles from "./AddToCartModalWithPrices.module.scss";

type Props = {
  product: Entity.Product;
  onClose: () => void;
};

const AddToCartModalWithPrices: React.FC<Props> = ({
  product,
  onClose,
}: Props) => {
  const prices = useProductPrices(product);

  return (
    <Modal onClose={onClose}>
      <div className={styles.variantSelectModal}>
        <Title as="p" size="h2" className={styles.variantSelectModalTitle}>
          Выберите тип товара
        </Title>
        <div className={styles.variantSelectModalBody}>
          <div className={styles.variantSelectModalVariants}>
            {prices.map(price => {
              return (
                <div
                  className={styles.variantPreviewWrapper}
                  key={price.priceTypeID}
                >
                  <div className={styles.variantPreview}>
                    <p className={styles.variantPreviewTitle}>
                      {PRICES[price.priceTypeID]}
                      {price.dateExpired &&
                        `, годен до ${formatDate(
                          price.dateExpired,
                          "DD.MM.YYYY"
                        )}`}
                    </p>

                    <div className={styles.variantPreviewActions}>
                      <Price
                        price={price.price}
                        priceOld={price.priceOld}
                        discount={price.discount}
                      />

                      {price.price > 0 && (
                        <AddToCart
                          counterWide
                          counterSize="large"
                          product={product}
                          price={price}
                          showExpiringPrices
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddToCartModalWithPrices;
